import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import styles from '../../utility/styles';

const slideUp = keyframes`
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
`;

const slideDown = keyframes`
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(100%);
    }
`;

const ModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    opacity: ${({ show }) => show ? 1 : 0};
    visibility: ${({ show }) => show ? 'visible' : 'hidden'};
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
`

const ModalContent = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${styles.colors.background};
    border-radius: 16px 16px 0 0;
    padding: 24px;
    max-height: 80vh;
    min-height: 300px;
    overflow-y: auto;
    animation: ${({ show }) => show ? slideUp : slideDown} 0.3s ease-in-out;
`

const Backdrop = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
`

export default function Modal({ show, onClose, children }) {
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        if (show) {
            setShouldRender(true);
        } else {
            const timer = setTimeout(() => setShouldRender(false), 300);
            return () => clearTimeout(timer);
        }
    }, [show]);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!shouldRender) return null;

    return (
        <ModalWrapper show={show}>
            <Backdrop onClick={handleBackdropClick} />
            <ModalContent show={show}>
                {children}
            </ModalContent>
        </ModalWrapper>
    )
}
